export const ENTITY_OVERRIDES = '__entityOverrides__';
